import { Controller } from "@hotwired/stimulus"

// Syncs Turbo frame navigation with the browser's address bar so the current
// category selection can be bookmarked or refreshed without losing context.
export default class extends Controller {
  connect() {
    this.pendingUrl = null
    this.handleFrameLoad = this.handleFrameLoad.bind(this)
    this.handleClick = this.handleClick.bind(this)

    this.element.addEventListener("turbo:frame-load", this.handleFrameLoad)
    this.element.addEventListener("click", this.handleClick)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.handleFrameLoad)
    this.element.removeEventListener("click", this.handleClick)
  }

  handleClick(event) {
    const link = event.target.closest("a[data-preserve-url]")
    if (!link) return

    this.pendingUrl = link.href
  }

  handleFrameLoad(event) {
    if (event.target !== this.element) return

    const fetchResponse = event.detail?.fetchResponse
    const responseUrl = fetchResponse?.response?.url
    const urlToApply = this.pendingUrl || responseUrl

    if (!urlToApply) {
      this.pendingUrl = null
      return
    }

    const nextUrl = this.formatRelativeUrl(urlToApply)
    if (!nextUrl || nextUrl === window.location.pathname + window.location.search + window.location.hash) {
      this.pendingUrl = null
      return
    }

    window.history.replaceState(window.history.state, "", nextUrl)
    this.pendingUrl = null
  }

  formatRelativeUrl(url) {
    try {
      const absoluteUrl = new URL(url, window.location.origin)
      if (absoluteUrl.origin !== window.location.origin) return null
      return `${absoluteUrl.pathname}${absoluteUrl.search}${absoluteUrl.hash}`
    } catch (error) {
      return null
    }
  }
}
